import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FC } from 'react';

interface InvalidDateRangeDialogProps {
  invalidDateRangeModalVisible: boolean;
  setInvalidDateRangeModalVisible: (visible: boolean) => void;
  t: (key: string) => string;
}

const InvalidDateRangeDialog: FC<InvalidDateRangeDialogProps> = ({
  invalidDateRangeModalVisible,
  setInvalidDateRangeModalVisible,
  t,
}) => (
  <Dialog
    visible={invalidDateRangeModalVisible}
    onHide={() => setInvalidDateRangeModalVisible(false)}
    header={t('common.date.invalidRange')}
    footer={
      <Button label={t('common.close')} onClick={() => setInvalidDateRangeModalVisible(false)} />
    }
  >
    <p>{t('common.date.invalidRangeMessage')}</p>
  </Dialog>
);

export default InvalidDateRangeDialog;
